export default __webpack_public_path__ + "static/media/keto_labels.eba9ce77.jpg";